<template>
  <!-- 明细表 -->
  <!--eslint-disable vue/no-unused-refs-->
  <div class="overdue-summary">
    <!-- 搜索区 -->
    <!-- eslint-disable-next-line vue/no-unused-refs -->
    <el-form :model="searchData" ref="search">
      <QS-search maxLine="2">
        <el-form-item prop="dateRange" label="欠款日期">
          <el-date-picker
            v-model="dateRange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item prop="orderStateList" label="租赁状态">
          <!-- 多选状态下使用 collapse-tags 否则会有界面bug -->
          <el-select
            v-model="searchData.orderStateList"
            clearable
            placeholder="请选择租赁状态"
            multiple
            collapse-tags
          >
            <el-option
              v-for="item in leaseStatusOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户来源" prop="customerType">
          <el-select
            v-model="searchData.customerType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in customerTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="customerName" label="客户名称">
          <el-select
            v-model="searchData.customerId"
            filterable
            clearable
            remote
            placeholder="请输入"
            :remote-method="loadNameData"
            :loading="oLoading.fuzzySearch"
            @visible-change="
              e => {
                changeValue(e, 'customerManage')
              }
            "
          >
            <el-option
              v-for="item in curstomerNameData"
              :key="item.id"
              :label="item.customerName"
              :value="item.id"
            >
              <CustomerNameOptionItem :data="item" />
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 还款状态 -->
        <el-form-item prop="" label="还款状态">
          <el-select
            clearable
            placeholder="请选择还款状态"
            v-model="searchData.finishState"
          >
            <el-option
              v-for="item in repaymentStateOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 车型 -->
        <CarBrandSeriesModel
          ref="carBrandSeriesModelRef"
          v-model="brandSeriesModel"
          :showModel="true"
          :filterScene="CAR_MODEL_FILTER_SCENE.IN_STOCK"
          ></CarBrandSeriesModel>

        <template slot="moreBtn">
          <el-form-item>
            <el-button
              :loading="oLoading.search"
              type="primary"
              @click="searchHandle"
              >查询</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button @click="reset('search')">重置</el-button>
          </el-form-item>
          <el-form-item>
            <export
              :exportTemplate="exportTemplate"
              filename="逾期汇总表.xlsx"
              :params="exportParams"
              v-if="judgePermission('under_lease_over_due_sum_list_export')"
            ></export>
          </el-form-item>
        </template>
      </QS-search>
    </el-form>

    <!-- 搜索数据总览 -->
    <div class="collect-box">
      <OperationSummary
        :summary="summary"
        :loading="oLoading.search"
      ></OperationSummary>
    </div>

    <!-- 列表 -->
    <QS-common-table
      :data="tableData"
      :columns="columns"
      :pagination="paginationData"
      @change="paginationChange"
    >
    </QS-common-table>

    <!-- 详情 -->
    <demand-rent-detail
      v-if="detailDialogObj.dialogVisible"
      :dialogVisible="detailDialogObj.dialogVisible"
      :data="detailDialogObj.data"
      width="980px"
      @close="detailDialogObj.dialogVisible = false"
    />
  </div>
</template>
<script>
import { parseQueryJsonStr } from '@/utils/querySchema'
import config from '../config/summary/overdueSummaryList'
import demandRentDetail from '../detail/summary/index.vue'
import CustomerNameOptionItem from '@/components/CustomerSelect/optionItem'
import OperationSummary from '@/components/OperationSummary/index.vue'
// eslint-disable-next-line import/no-cycle
import { getOverDueSummaryList, amountSummary } from '@/api/domain/orders'

import Mixin from '../mixins'
import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'

const mixin = Mixin({
  getListFn: getOverDueSummaryList,
  searchData: {
    startDate: '', // 欠款开始时间
    endDate: '', // 欠款结束时间
    orderStateList: [], // 租赁状态
    customerType: '', // 客户来源
    customerName: '', // 客户名称
    customerId: '', // 客户ID
    finishState: '', // 还款状态
    brandId: '', // 品牌ID
    seriesId: '', // 系列ID
    modelId: '', // 车型ID
  },
  exportTemplate: 'OverDueSummary',
  otherFn: 'amountSummary',
})

export default {
  mixins: [mixin],
  components: {
    demandRentDetail,
    OperationSummary,
    CustomerNameOptionItem,
  },
  data() {
    const { query: queryStr } = this.$route?.query
    const queryObj = queryStr ? parseQueryJsonStr(queryStr) : {}
    const {
      columns,
      customerTypeOptions,
      summaryMap,
      repaymentStateOption,
      leaseStatusOption,
    } = config.call(this)
    return {
      columns,
      customerTypeOptions,
      summaryMap,
      summary: [],
      repaymentStateOption,
      leaseStatusOption,
      detailDialogObj: {
        dialogVisible: false,
        data: null,
      },
      queries: queryObj,
      brandSeriesModel: {},
      CAR_MODEL_FILTER_SCENE,
    }
  },
  watch: {
    brandSeriesModel: {
      handler(val) {
        this.searchData.brandId = val.brandId
        this.searchData.seriesId = val.seriesId
        this.searchData.modelId = val.modelId
      },
      deep: true,
    },
  },
  created() {
    this.getRouteQuery()
  },
  methods: {
    getRouteQuery() {
      const { search = {} } = this.queries
      const { dateRange = '', customerType = '', finishState = '' } = search

      if (dateRange !== '') {
        this.dateRange = dateRange
      }
      if (customerType !== '') {
        this.searchData.customerType = customerType
      }
      if (finishState !== '') {
        this.searchData.finishState = finishState
      }
    },
    // 查看详情
    // eslint-disable-next-line vue/no-unused-properties
    detailHandle(row) {
      this.detailDialogObj.dialogVisible = true
      this.detailDialogObj.data = {
        customerType: row.customerType,
        customerId: row.customerId,
        startDate: this.searchData.startDate,
        endDate: this.searchData.endDate,
        finishState: this.searchData.finishState, // 还款状态
        carModelId: this.searchData.carModelId, // 车型
        orderStateList: this.searchData.orderStateList, // 租赁状态
        brandId: this.searchData.brandId,
        seriesId: this.searchData.seriesId,
        modelId: this.searchData.modelId,
      }
    },
    // 金额统计
    // eslint-disable-next-line vue/no-unused-properties
    async amountSummary() {
      const arr = []
      const { code, data } = await amountSummary({
        ...this.getSearchParamrs(),
      })
      if (code === 1) {
        Reflect.ownKeys(data || {}).forEach((key) => {
          arr.push({
            subTitle: this.summaryMap[key],
            numbers: data[key] || '0',
          })
        })
        this.summary = arr
      }
    },
  },
}
</script>
<style scoped lang="scss">
[class^='overdue-'] {
  ::v-deep .operation-summary .content-box .content-perIt .need-show-text {
    align-items: baseline;
    padding-top: 4px;
    .enlarge-content {
      padding-right: 2px;
    }
  }
  .collect-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
  }
}
.customer {
  display: flex;
  flex-direction: row;
  &-name {
    width: 100px;
    height: 35px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &-phone {
    color: #8492a6;
    font-size: 13px;
    padding-left: 20px;
  }
}
</style>
